/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReprocessGuestyEventsResult { 
    /**
     * The events that were queued to be processed again
     */
    queued_event_ids?: Array<string>;
    /**
     * The requested events that were left untouched, either because they do not exist or because they are already queued
     */
    ignored_event_ids?: Array<string>;
}

